// extracted by mini-css-extract-plugin
export var wrapper = "History-module--wrapper--2AlSw";
export var blockContent = "History-module--blockContent--nTDm6";
export var container = "History-module--container--2DD10";
export var images = "History-module--images--11e80";